module.exports = __webpack_public_path__ + "assets/img/22_1307_big.4f2ce07b.jpg";